import { render, staticRenderFns } from "./MainDemoDark.vue?vue&type=template&id=6586ce21"
import script from "./MainDemoDark.vue?vue&type=script&lang=js"
export * from "./MainDemoDark.vue?vue&type=script&lang=js"
import style0 from "./MainDemoDark.vue?vue&type=style&index=0&id=6586ce21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports